DialogController = App.loadClass 'core::Angular/DialogController'

class exports.IngredionDialogController extends DialogController
    constructor: (@state, @scope, @transitions, @modalInstance, @http, @survey) ->
        super(@scope, @transitions, @modalInstance)

        @scope.title = 'Ingredion'
        @scope.editing = true

        # We should always have a survey, but just in case..
        @blank_survey =
            for_ingredion: null
            nearby_corn: null
            corn_is_gmo: null
            nearby_fields: [
                direction: null
                distance: null
            ]
        @scope.survey = @survey ? @blank_survey

        @scope.directions = [
            'North',
            'Northeast',
            'East'
            'Southeast',
            'South',
            'Southwest',
            'West',
            'Northwest'
        ]

        @scope.distances = ['160 feet or less', '161 to 600 feet', 'More than 600 feet']


        @scope.$watch 'survey.for_ingredion', (val) =>
            if @scope.editing and not val
                @scope.survey.nearby_corn = null

        @scope.$watch 'survey.nearby_corn', (val) =>
            if @scope.editing and not val
                @scope.survey.corn_is_gmo = null

        @scope.$watch 'survey.corn_is_gmo', (val) =>
            if @scope.editing and not val
                @scope.survey.nearby_fields = [
                    distance: null
                    direction: null
                ]


        @scope.addNearbyField = () =>
            @scope.survey.nearby_fields.push
                direction: null
                distance: null


        @scope.removeNearbyField = (field) =>
            # If there's only one nearby field reset direction and distance to null. Otherwise, remove it
            if @scope.survey.nearby_fields.length is 1
                return @scope.survey.nearby_fields[0] =
                    distance: null
                    direction: null

            _.pull @scope.survey.nearby_fields, field


    save: (pretending) =>
        @http.post 'backend/grower/maps-conversion/validate-ingredion-survey', { survey: @scope.survey }
        .then (response) =>
            @modalInstance.close(@scope.survey) if not pretending
